<template>
  <div
    class="tab-pane fade"
    :class="{ active: 'Transactions' === activeMenuSelection, show: 'Transactions' === activeMenuSelection }"
    id="Transactions"
    role="tabpanel"
    aria-labelledby="Transactions-tab"
  >
    <div class="card h-100">
      <div class="card-body">
        <div class="container">
          <div class="row">
            <div class="col-sm-10">
              <div class="collapse" :class="{ show: showFilters }" id="collapseTransactionsFilters">
                <div class="card card-body wallet-filter-panel">
                  <h5 class="card-title">{{ t("filtersLabel") }}</h5>
                  <label for="filterByTransactionType">{{ t("typeLabel") }}</label>
                  <select id="filterByTransactionType" class="form-select form-select-sm mb15" v-model="selectedType">
                    <option value="0">{{ t("allOrderTypesLabel") }}</option>
                    <option value="1">{{ t("dividendLabel") }}</option>
                    <option value="2">{{ t("transactionExchangeLabel") }}</option>
                    <option value="3">{{ t("transactionLabel") }}</option>
                  </select>
                  <label for="filterBytransactionCurrency">{{ t("currencyLabel") }}</label>
                  <select id="filterBytransactionCurrency" class="form-select form-select-sm mb15" v-model="selectedCurrency">
                    <option value="0">{{ t("allCurrenciesLabel") }}</option>
                    <option value="1">BGN</option>
                    <option value="2">EUR</option>
                    <option value="3">{{ t("othersLabel") }}</option>
                  </select>
                  <label for="filterBytransactionAmount">{{ t("amountLabel") }}</label>
                  <div class="dropdown mb15">
                    <button
                      id="filterBytransactionAmount"
                      class="btn btn-light form-select form-select-sm transaction-amount-select-button"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ selectedAmountLabel }}
                    </button>
                    <ul class="dropdown-menu transaction-amount-dropdown-menu" aria-labelledby="filterBytransactionAmount">
                      <li v-for="option in amountRangeOptions" :key="option.value">
                        <label class="dropdown-item transaction-amount-dropdown-item" @click.stop>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :value="option.value"
                            :checked="isAmountRangeSelected(option.value)"
                            @change="toggleAmountRange(option.value)"
                          />
                          <span>{{ option.label }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <label for="filterByTransactionDate">{{ t("periodLabel") }}</label>
                  <select id="filterByTransactionDate" class="form-select form-select-sm mb15" v-model="selectedPeriod">
                    <option value="0">{{ t("thisMonthLabel") }}</option>
                    <option value="1">{{ t("past3MonthLabel") }}</option>
                    <option value="2">{{ t("past6MonthLabel") }}</option>
                    <option value="3">{{ t("pastYearLabel") }}</option>
                    <option value="4">YTD</option>
                    <option value="5">{{ t("fromDateLabel") }}</option>
                  </select>
                  <Datepicker
                    class="mb15"
                    v-if="5 === parseInt(filterTransactionsByPeriod)"
                    v-model="selectedDate"
                    format="yyyy-MM-dd"
                    placeholder="yyyy-mm-dd"
                    :minDate="new Date(minDateForWallet)"
                    :maxDate="new Date()"
                    showNowButton
                  />
                  <button type="button" class="btn btn-primary w-100" @click.prevent="$emit('reset-filters')">
                    {{ t("clearLabel") }}
                  </button>
                </div>
              </div>
              <div class="collapse" :class="{ show: showSorting }" id="collapseTransactionsSorting">
                <div class="card card-body wallet-filter-panel">
                  <label for="sortingTransactions">{{ t("sortingLabel") }}</label>
                  <select id="sortingTransactions" class="form-select form-select-sm mb15" v-model="selectedSort">
                    <option value="0">{{ t("sortDateAscLabel") }}</option>
                    <option value="1">{{ t("sortDateDescLabel") }}</option>
                    <option value="2">{{ t("sortAmountAscLabel") }}</option>
                    <option value="3">{{ t("sortAmountDescLabel") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="wallet-tab-actions">
                <button
                  type="button"
                  class="btn btn-link"
                  :class="{ active: showFilters }"
                  :aria-expanded="showTransactionFilters"
                  aria-controls="collapseTransactionsFilters"
                  @click.prevent="toggleFilters"
                >
                  <i class="icon ion-md-options"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  :class="{ active: showSorting }"
                  :aria-expanded="showTransactionSorting"
                  aria-controls="collapseTransactionsSorting"
                  @click.prevent="toggleSorting"
                >
                  <i class="icon ion-md-reorder"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="wallet-history">
          <div v-if="loading" class="wallet-history-loading">
            <Preloader />
          </div>
          <div v-else-if="1200 < windowsWidth" class="table-responsive">
            <table class="table transactions-table">
              <colgroup>
                <col class="transactions-date-column" />
                <col class="transactions-type-column" />
                <col class="transactions-amount-column" />
                <col class="transactions-note-column" />
              </colgroup>
              <thead>
                <tr>
                  <th>{{ t("dateLabel") }}</th>
                  <th>{{ t("typeLabel") }}</th>
                  <th class="price-data">{{ t("transactionsAmountLabel") }}</th>
                  <th>{{ t("noteLabel") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction, index) in transactions" :key="index">
                  <td>{{ getShortDate(transaction.ts) }}</td>
                  <td>{{ getTransactionTypeLabel(transaction.tt) }}</td>
                  <td class="price-data">
                    {{ formatTransactionAmount(transaction.am, transaction.cc).replace(" ", "&nbsp;") }}
                  </td>
                  <td>{{ transaction.note }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else v-for="(transaction, index) in transactions" :key="index">
            <div class="card h-100">
              <div class="card-body xsmall-font-size">
                <div class="container p-0">
                  <div class="row justify-content-between">
                    <div class="col-6">
                      <strong>{{ getTransactionTypeLabel(transaction.tt) }}</strong><br />
                      {{ getDate(transaction.ts) }}<br />
                      {{ formatTransactionAmount(transaction.am, transaction.cc).replace(" ", "&nbsp;") }}
                    </div>
                    <div class="col-6 text-end my-auto">
                      <button
                        type="button"
                        class="btn btn-primary"
                        :class="{ 'xsmall-font-size': 1200 > windowsWidth }"
                        @click.prevent="$emit('open-transaction-details', transaction)"
                      >
                        &rarr;
                      </button>&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import Preloader from "@/components/ui/Preloader.vue";

export default {
  name: "WalletTransactionsTab",
  components: {
    Datepicker,
    Preloader
  },
  props: {
    activeMenuSelection: {
      type: String,
      required: true
    },
    transactions: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    windowsWidth: {
      type: Number,
      required: true
    },
    minDateForWallet: {
      type: String,
      required: true
    },
    filterSelectedDate: {
      type: [Date, String, Number, Object],
      default: null
    },
    filterTransactionsByType: {
      type: [Number, String],
      required: true
    },
    filterTransactionsByCurrency: {
      type: [Number, String],
      required: true
    },
    filterTransactionsByAmount: {
      type: [Array, Number, String],
      required: true
    },
    filterTransactionsByPeriod: {
      type: [Number, String],
      required: true
    },
    sortTransactions: {
      type: [Number, String],
      required: true
    },
    showTransactionFilters: {
      type: Boolean,
      required: true
    },
    showTransactionSorting: {
      type: Boolean,
      required: true
    },
    translator: {
      type: Function,
      required: true
    },
    priceFormatter: {
      type: Function,
      required: true
    },
    dateFormatter: {
      type: Function,
      required: true
    },
    shortDateFormatter: {
      type: Function,
      required: true
    },
    capitalizeFormatter: {
      type: Function,
      required: true
    }
  },
  emits: [
    "update:filterSelectedDate",
    "update:filterTransactionsByType",
    "update:filterTransactionsByCurrency",
    "update:filterTransactionsByAmount",
    "update:filterTransactionsByPeriod",
    "update:sortTransactions",
    "update:showTransactionFilters",
    "update:showTransactionSorting",
    "reset-filters",
    "open-transaction-details"
  ],
  computed: {
    selectedDate: {
      get() {
        return this.filterSelectedDate;
      },
      set(value) {
        this.$emit("update:filterSelectedDate", value);
      }
    },
    selectedType: {
      get() {
        return this.filterTransactionsByType;
      },
      set(value) {
        this.$emit("update:filterTransactionsByType", value);
      }
    },
    selectedCurrency: {
      get() {
        return this.filterTransactionsByCurrency;
      },
      set(value) {
        this.$emit("update:filterTransactionsByCurrency", value);
      }
    },
    selectedAmount: {
      get() {
        return this.filterTransactionsByAmount;
      },
      set(value) {
        this.$emit("update:filterTransactionsByAmount", value);
      }
    },
    selectedAmountRanges() {
      if (Array.isArray(this.filterTransactionsByAmount)) {
        return this.filterTransactionsByAmount.map(item => parseInt(item));
      }

      const value = parseInt(this.filterTransactionsByAmount);
      return value === 0 ? this.amountRangeOptions.map(option => option.value) : [value];
    },
    amountRangeOptions() {
      return [
        { value: 1, label: "> 10,000" },
        { value: 2, label: "1,000.00 - 10,000.00" },
        { value: 3, label: "100.00 - 1,000.00" },
        { value: 4, label: "10.00 - 100.00" },
        { value: 5, label: "1.00 - 10.00" },
        { value: 6, label: "< 1" }
      ];
    },
    selectedAmountLabel() {
      if (this.selectedAmountRanges.length === this.amountRangeOptions.length) {
        return this.t("allAmountsLabel");
      }

      if (this.selectedAmountRanges.length === 1) {
        const selectedOption = this.amountRangeOptions.find(option => option.value === this.selectedAmountRanges[0]);
        return selectedOption?.label || this.t("amountLabel");
      }

      return `${this.selectedAmountRanges.length} / ${this.amountRangeOptions.length}`;
    },
    selectedPeriod: {
      get() {
        return this.filterTransactionsByPeriod;
      },
      set(value) {
        this.$emit("update:filterTransactionsByPeriod", value);
      }
    },
    selectedSort: {
      get() {
        return this.sortTransactions;
      },
      set(value) {
        this.$emit("update:sortTransactions", value);
      }
    },
    showFilters() {
      return true === this.showTransactionFilters;
    },
    showSorting() {
      return true === this.showTransactionSorting;
    }
  },
  methods: {
    t(key, ...args) {
      return this.translator(key, ...args);
    },
    formatPrice(...args) {
      return this.priceFormatter(...args);
    },
    formatTransactionAmount(amount, currency) {
      if ("BGN" === currency?.toString().toUpperCase()) {
        return `BGN ${this.formatPrice(amount, "", 2)}`;
      }

      return this.formatPrice(amount, currency, 2);
    },
    getDate(...args) {
      return this.dateFormatter(...args);
    },
    getShortDate(...args) {
      return this.shortDateFormatter(...args);
    },
    capitalizeFirstLetter(...args) {
      return this.capitalizeFormatter(...args);
    },
    getTransactionTypeLabel(type) {
      const normalizedType = type?.toString().toLowerCase() || "";
      if ("dividend" === normalizedType || "divident" === normalizedType) {
        return this.t("dividendLabel");
      }
      if ("exchange" === normalizedType) {
        return this.t("transactionExchangeLabel");
      }
      if ("transaction" === normalizedType) {
        return this.t("transactionLabel");
      }

      return this.capitalizeFirstLetter(type);
    },
    isAmountRangeSelected(value) {
      return this.selectedAmountRanges.includes(parseInt(value));
    },
    toggleAmountRange(value) {
      const range = parseInt(value);
      const selected = this.selectedAmountRanges.includes(range)
        ? this.selectedAmountRanges.filter(item => item !== range)
        : [...this.selectedAmountRanges, range].sort((a, b) => a - b);

      this.selectedAmount = selected;
    },
    toggleFilters() {
      this.$emit("update:showTransactionFilters", !this.showTransactionFilters);
      this.$emit("update:showTransactionSorting", false);
    },
    toggleSorting() {
      this.$emit("update:showTransactionSorting", !this.showTransactionSorting);
      this.$emit("update:showTransactionFilters", false);
    }
  }
};
</script>

<style scoped>
.wallet-tab-actions {
  display: flex;
  gap: 0.25rem;
  justify-content: flex-end;
}

.wallet-tab-actions .btn-link {
  align-items: center;
  border: 1px solid transparent;
  display: inline-flex;
  justify-content: center;
  min-height: 2rem;
  min-width: 2rem;
  padding: 0.25rem 0.5rem;
}

.wallet-tab-actions .btn-link:focus,
.wallet-tab-actions .btn-link:focus-visible {
  box-shadow: none;
  outline: 0;
}

.wallet-tab-actions .btn-link.active {
  border-color: #0d6efd;
}

.wallet-history-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 8rem;
}

.transactions-date-column {
  width: 18%;
}

.transactions-type-column {
  width: 20%;
}

.transactions-amount-column {
  width: 16%;
}

.transactions-note-column {
  width: 46%;
}

.transactions-table th.price-data,
.transactions-table td.price-data {
  text-align: right;
}

.transaction-amount-select-button {
  background-color: #fff;
  border: 1px solid #ced4da;
  height: 2rem;
  padding-right: 2rem;
  text-align: left;
  width: 100%;
}

.transaction-amount-dropdown-menu {
  border-radius: 0;
  min-width: 100%;
  padding: 0;
}

.transaction-amount-dropdown-item {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  min-height: 2.4rem;
}
</style>
